<template>

  <div class="row" ref="documentsForm">
    <div class="col-xs-12 col-md-12 col-sm-12">
      <ValidationObserver v-slot="{ handleSubmit }" ref="formValidator">
        <card>
          <div slot="header">
            <h4 class="card-title">
              {{ formTitle }}
            </h4>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-12 col-sm-12">
                <div class="row">
                  <div class="col-md-12">
                    <ValidationProvider
                      vid="en.name"
                      rules="required"
                      name="The Name"
                      v-slot="{ passed, failed,errors }">
                      <fg-input type="name"
                                :error="failed ? errors[0]: null"
                                label="Name"
                                name="name"
                                fou
                                v-model="formData.name">
                      </fg-input>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <fg-select
                      name="speakers"
                      size="large"
                      filterable
                      clearable
                      placeholder="Select Speakers"
                      :input-classes="'select-default'"
                      :label="'Speakers'"
                      :list="builderData.speakersList"
                      :listItemLabel="'name'"
                      :listItemValue="'id'"
                      v-model="formData.speaker_id">
                    </fg-select>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label>File</label>
                      <el-tooltip placement="right"  >
                        <div slot="content">
                          (PDF only)
                        </div>
                        <span style="margin: 0 5px;">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                             class="bi bi-question-circle" viewBox="0 0 16 16">
                      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                      <path
                        d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z"/>
                    </svg>
                    </span>
                      </el-tooltip>
                      <single-file-uploader-file-manager
                        :preview-width="'200px'"
                        :preview-height="'200px'"
                        :fileType="'document'"
                        v-model="formData.document"
                        :accepted-files="pdfExtensions">
                      </single-file-uploader-file-manager>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card-footer text-right">
            <l-button :disabled="entityNotFoundError || submitting" @click.prevent="handleSubmit(submit)"
                      nativeType="submit"
                      type="info" wide>Submit
            </l-button>
            <l-button @click="$router.push('/sessions/documents/list/'+formData.session_id)" type="danger" wide>Cancel
            </l-button>
          </div>
        </card>
      </ValidationObserver>

    </div>

  </div>
</template>
<script>
import { extend } from "vee-validate";
import {Option, Select, Tooltip} from "element-ui";
import FgSelect from "@/components/Inputs/formGroupSelect";
import FormGroupTextArea, {ImageUploader, PrimeUploader, PrimeVideoUploader, Switch as LSwitch} from "@/components";
import Editor from '@tinymce/tinymce-vue'
import SingleFileUploaderFileManager from "../../../components/FileManager/SingleFileUploaderFileManager";



extend("required", {
  message: "{_field_} is required"
});

export default {

  components: {
    SingleFileUploaderFileManager,
    FormGroupTextArea,
    [Option.name]: Option,
    [Select.name]: Select,
    [Tooltip.name]: Tooltip,
    FgSelect,
    LSwitch,
    PrimeUploader,
    ImageUploader,
    PrimeVideoUploader,
    'editor': Editor
  },

  data() {
    return {
      editMode: false,
      loader: {},
      id: undefined,
      editorConfig: this.getEditorConfig(),
      editorKey: process.env.VUE_APP_TINY_EDITOR_KEY,
      pdfExtensions: this.getPdfExtensions(),
      formTitle: "",
      entityNotFoundError: false,
      submitting: false,
      formData: {
        name: "",
        document: "",
        session_id: '',
        speaker_id: '',
      },
      builderData: {
        speakersList: [],
        forumList: [],
      },

    };
  },
  mounted() {
    this.loader = this.$loading.show({
      container: this.$refs.documentsForm
    });
    this.formData.session_id = this.$route.params['session_id'];
    let data = {session_id: this.formData.session_id}
    this.axios.post("sessions/documents/builder", data).then((response) => {
      this.builderData.speakersList = response.data.speakers;
      this.builderData.forumList = response.data.forums;

      this.id = this.$route.params['id'];


      if (this.id !== undefined) {
        this.editMode = true;
        this.formTitle = "Edit Document";
        this.getDocument();
      } else {
        this.editMode = false;
        this.formTitle = "Add Document";
        this.loader.hide();
      }
    }).catch((error) => {
      console.error(error);
    })
  },
  methods: {
    getDocument() {
      let data = {
        'id': this.id,
      };
      this.axios.post("sessions/documents/get", data).then((response) => {
        this.formData = response.data;
        this.loader.hide();
      }).catch((error) => {
        if (error.response.status === 404) {
          this.entityNotFoundError = true;
          this.$notify({
            message: "Document Not Found",
            timeout: 2000,
            type: 'danger'
          });
          this.loader.hide();
        } else {
          console.error(error);
        }
      })
    },
    submit() {
      let request;
      let successMessage;
      if (this.formData.document == ""){
        this.$notify({
          message: "You have to add file",
          timeout: 2000,
          type: 'danger'
        });
      }
      this.submitting = true;
      if (this.editMode === true) {
        request = this.axios.put("sessions/documents/update/" + this.id, this.formData);
        successMessage = "Document Updated Successfully";
      } else {
        request = this.axios.post("sessions/documents/create", this.formData);
        successMessage = "Document Added Successfully";
      }

      request.then((response) => {
        this.$notify({
          message: successMessage,
          timeout: 1000,
          type: 'success'
        })
        this.$router.push("/sessions/documents/list/"+this.formData.session_id);
      }).catch((error) => {
        if (error.response.status === 422) {
          this.$refs.formValidator.setErrors(error.response.data.errors);
        } else {
          console.log(error.response)
        }
      }).finally(() => {
        this.submitting = false;
      })
    },
    generateSomeFields() {
      let newUrl = '';
      if (this.formData.title) {
        newUrl = this.formData.title.replace(/\s+/g, "-").toLowerCase();
        newUrl = newUrl.replace(/[^ءأ-يa-zA-Z0-9-]/g, "");
        newUrl = newUrl.replace(/([-]+)/g, "-");
      }
      this.formData.url = newUrl;
    },
  }
}
</script>
